import React, { useState, useEffect } from "react";
import Select from 'react-select';
import {
    CButton,
    CCard,
    CCardBody,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CFormLabel,
    CFormInput,
    CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem
} from "@coreui/react";
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus } from 'lucide-react'
import CustomAgGrid from './../../components/shared/CustomAgGrid';
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import SaveRisksData from "../../services/general/saveRisksData.api";
import DeleteDiagnosis from "../../services/general/deleteDiagnosis.api";
import DiagnosisDetails from './DiagnosisDetails';
import Pageloader from "../../components/shared/Pageloader";
import Accordions from '../../components/shared/Accordians';
import AccordianEditDelete from "../../components/shared/AccordianEditDelete";
import SaveExtra from "../../services/general/saveExtraData.api";
import KeywordsSuggestion from "../../components/shared/KeywordsSuggestion";
import AccordianSuggestion from "./AccordianSuggestion";
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import ReasonSuggestion from "./ReasonSuggestion";


const SuggestionDiagnosis = () => {
    const [diagnosisData, setDiagnosisData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [suggestionModalVisible, setSuggestionModalVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentDiagnosisId, setCurrentDiagnosisId] = useState(null);
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [assessment, setAssessment] = useState([]);
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [deleteVisibleId, setDeleteVisibleId] = useState(null)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [activeTab, setActiveTab] = useState("add");

    const [selectedSuggestion, setSelectedSuggestion] = useState({ value: 'plan', label: 'Plan' })
    const [boxView, setBoxView] = useState('box')
    const [title, setTitle] = useState("")
    const [groupedData, setGroupedData] = useState({})
    const [suggestionId, setSuggestionId] = useState(null)

    const [accordions, setAccordions] = useState([]);
    const [currentParentId, setCurrentParentId] = useState(null);
    const [newTitle, setNewTitle] = useState('');
    const [suggestionTitle, setSuggestionTitle] = useState([])
    const [editMode, setEditMode] = useState(false);
    const [editingAccordionId, setEditingAccordionId] = useState(null);

    const [suggestionData, setSuggestionData] = useState([])
    const [suggestionIndex, setSuggestionIndex] = useState(null);

    const [saveResoanChange, setSaveResoanChange] = useState({})


    const saveToLocalStorage = (data) => {
        // localStorage.setItem('SuggestionDiagnosis', JSON.stringify(data));
    };

    useEffect(() => {
        if (selectedDiagnosis) {

            let result = suggestionData.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)

            if (result.length > 0) {
                setAccordions(result[0].Data)
            } else {
                setAccordions({ diagnosis: selectedDiagnosis || null, accordions: [] })
            }


        }
    }, [selectedDiagnosis])


    const addAccordion = (parentId = null) => {

        if (editMode) {
            setAccordions((prev) => {
                const updatedAccordions = updateAccordionTitle(prev.accordions, editingAccordionId, newTitle);
                const updatedData = { ...prev, accordions: updatedAccordions };
                saveToLocalStorage(updatedData);
                return updatedData;
            });

        } else {
            const newAccordion = {
                id: Date.now(),
                title: newTitle,
                suggestions: [],
                children: [],
            };

            setAccordions((prev) => {

                const updatedAccordions = parentId
                    ? updateNestedAccordions(prev.accordions, parentId, newAccordion)
                    : [...prev?.accordions, newAccordion];

                const updatedData = { ...prev, accordions: updatedAccordions };
                saveToLocalStorage(updatedData);
                return updatedData;
            });
        }

        closeModal();
    };

    const updateAccordionTitle = (list, accordionId, newTitle) =>
        list.map((item) =>
            item.id === accordionId
                ? { ...item, title: newTitle }
                : { ...item, children: updateAccordionTitle(item.children, accordionId, newTitle) }
        );

    const updateNestedAccordions = (list, parentId, newAccordion) =>
        list.map((item) =>
            item.id === parentId
                ? { ...item, children: [...item.children, newAccordion] }
                : { ...item, children: updateNestedAccordions(item.children, parentId, newAccordion) }
        );

    const editAccordion = (accordionId, currentTitle) => {
        setEditMode(true);
        setEditingAccordionId(accordionId);
        setNewTitle(currentTitle);
        setModalVisible(true);
    };

    const addSuggestion = (parentId) => {

        let suggestionText = suggestionTitle;

        if (suggestionText) {
            setAccordions((prev) => {
                const updatedSuggestions = updateNestedSuggestions(prev.accordions, parentId, suggestionText);
                const updatedData = { ...prev, accordions: updatedSuggestions };
                saveToLocalStorage(updatedData);
                return updatedData;
            });
        }
        setSuggestionTitle([])
        setSuggestionModalVisible(false)
    };

    const updateNestedSuggestions = (list, parentId, suggestion) =>
        list.map((item) =>
            item.id === parentId
                ? {
                    ...item,
                    suggestions: {
                        ...item.suggestions,
                        suggestionName: suggestion,
                        orders: []
                    }
                }
                : {
                    ...item,
                    children: updateNestedSuggestions(item.children, parentId, suggestion)
                }
        );

    const openModal = (parentId = null) => {
        setCurrentParentId(parentId);
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
        setNewTitle('');
        setEditingAccordionId(null)
        setEditMode(false)
    };

    const deleteAccordion = (parentId) => {
        setAccordions((prev) => {
            const updatedAccordions = removeAccordionById(prev.accordions, parentId);
            const updatedData = { ...prev, accordions: updatedAccordions };
            saveToLocalStorage(updatedData);
            return updatedData;
        });
    };

    const removeAccordionById = (list, accordionId) =>
        list.filter((item) => item.id !== accordionId).map((item) => ({
            ...item,
            children: removeAccordionById(item.children, accordionId),
        }));

    const deleteDiagnosis = async (e) => {
        // await SaveRisksData("DELETE", "", "", "", deleteVisibleId?.id);
        // Update local storage data
        let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || [];
        const updatedData = localData.filter(diagnosis => diagnosis.id !== deleteVisibleId?.id);
        localStorage.setItem('SuggestionDiagnosis', JSON.stringify(updatedData));

        // Update state data
        getData()
        setDeleteVisibleId(null)
        setDiagnosisData(updatedData);
    };

    const handleEditDiagnosis = (e) => {
        setIsEditing(true);
        setCurrentDiagnosisId(e.id);
        setSelectedDiagnosis({ value: e.id, label: e.Name });
        setTitle(e.Title)
        setAssessment(e.assessment ? (setSelectedSuggestion({ value: 'assessment', label: 'Assessment' }), e.assessment.split(",")) : []);
        setPlans(e.plan ? (setSelectedSuggestion({ value: 'plan', label: 'Plan' }), e.plan.split(",")) : [])

        setModalVisible(true);
    };



    const buttonList = [
        { Name: 'Edit' }, { Name: 'Delete' }];

    const handleOnClick = () => {
        setIsEditing(false);
        setCurrentDiagnosisId(null);
        // setSelectedDiagnosis(null);
        setAssessment([]);
        setPlans([]);
        setModalVisible(true);
        setCurrentParentId(null)
        // setSelectedSuggestion(null)
    };

    const handelSubmit = async () => {

        setIsLoading(true)
        try {
            if (!selectedDiagnosis) {
                alert("Please select a diagnosis.");
                return;
            }

            let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || [];

            let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
            if (SuggestionData.length > 0) {
                await SaveExtra('Update', 'planSuggestion', JSON.stringify(accordions), SuggestionData[0].Id);
                toast.success('Successfully Submit', toastConfig)
            } else {
                await SaveExtra('Insert', 'planSuggestion', JSON.stringify(accordions));
                toast.success('Successfully Submit', toastConfig)
            }

            setModalVisible(false);
            setSaveResoanChange({})
            getData();



        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    };

    const getData = async () => {
        setIsPageLoading(true)
        try {


            let response = await GetDiagnosisData("");
            let diagnosis = JSON.parse(response.d)?.Data;

            let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || [];

            // setSuggestionData(localData)
            // let responseRisks = await GetDiagnosisData("Risks");
            // let localData = JSON.parse(responseRisks.d)?.Data;

            let data = await SaveExtra('Get_By_Type', 'planSuggestion', '', '')
            data = JSON.parse(data.d)?.Data || [];
            // console.log("parse data", data)
            if (data) {
                data = data?.map((item) => {


                    return {
                        Id: item.Id,
                        Data: JSON.parse(item?.JsonData)
                    }
                })
            }

            setSuggestionData(data);
            updateDiagnosisOptions(diagnosis);

        } catch (error) {
            console.log(error)
        } finally {
            setIsPageLoading(false);
        }
    };

    const updateDiagnosisOptions = (data) => {

        const options = data.map(item => ({
            value: item.id,
            label: item.Name
        }));
        setDiagnosisOptions(options);
    };

    useEffect(() => {
        getData();
    }, []);




    const editSuggestion = (parentId, suggestionIndex) => {

        const newSuggestion = suggestionTitle;
        if (newSuggestion) {
            setAccordions((prev) => {
                const updatedSuggestions = updateEditNestedSuggestions(prev.accordions, parentId, suggestionIndex, newSuggestion);
                const updatedData = { ...prev, accordions: updatedSuggestions };
                saveToLocalStorage(updatedData);
                return updatedData;
            });
        }
        setSuggestionTitle([]);
        setEditMode(false);
        setSuggestionModalVisible(false);
        setSuggestionIndex(null);
    };


    const updateEditNestedSuggestions = (list, parentId, suggestionIndex, newSuggestion) =>
        list.map((item) =>
            item.id === parentId
                ? {
                    ...item,
                    suggestions: {
                        ...item.suggestions,
                        suggestionName: newSuggestion,
                    },
                }
                : {
                    ...item,
                    children: item.children
                        ? updateEditNestedSuggestions(item.children, parentId, suggestionIndex, newSuggestion)
                        : item.children,
                }
        );

    const handleSuggestionsChange = (updatedSuggestions, parentId) => {

        setAccordions((prev) => {
            const updatedData = {
                ...prev,
                accordions: updateNestedSuggestionsResoan(prev.accordions, parentId, updatedSuggestions),
            };

            return updatedData;
        });
        return true
    };

    const updateNestedSuggestionsResoan = (list, parentId, updatedSuggestions) =>
        list.map((item) =>
            item.id === parentId
                ? { ...item, suggestions: { ...item.suggestions, orders: updatedSuggestions } }
                : {
                    ...item,
                    children: updateNestedSuggestionsResoan(item.children || [], parentId, updatedSuggestions),
                }
        );


    const handleReasonSumbit = () => {

        let data = handleSuggestionsChange(saveResoanChange?.formattedSuggestions, saveResoanChange?.parentId)
        if (data) {
            handelSubmit()
        }

    }


    const renderAccordions = (list, index) => {
        return <div className=" ">
            <CRow>
                <div>
                    {list?.map((item) => (

                        <AccordianEditDelete
                            title={item.title}
                            accordion={item}
                            editAccordion={editAccordion}
                            deleteAccordion={deleteAccordion}
                            content={
                                <div>

                                    <div className="d-flex gap-2 justify-content-center" style={{ marginTop: '-20px' }}>
                                        <CButton
                                            variant="outline"
                                            onClick={() => openModal(item.id)}
                                            color="info"
                                            className="custom-button shadow-sm"
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "500",

                                            }}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i>Add Title
                                        </CButton>
                                        <CButton
                                            variant="outline"
                                            color="warning "
                                            onClick={() => {

                                                if (item.suggestions && !Array.isArray(item.suggestions) && item?.suggestions?.suggestionName.length > 0) {

                                                    item?.suggestions?.suggestionName?.map((s, index) => {
                                                        setSuggestionId(item.id)
                                                        setSuggestionModalVisible(true)
                                                        setSuggestionIndex(index)
                                                        setEditMode(true)
                                                        setSuggestionTitle(() => {

                                                            let data = item?.suggestions?.suggestionName
                                                            return data
                                                        })
                                                    })
                                                } else {

                                                    setSuggestionId(item.id);
                                                    setSuggestionModalVisible(true);
                                                }

                                            }}
                                            className={`custom-button shadow-sm  `}
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            <i className="bi bi-lightbulb me-1"></i>Add/Edit Suggestions
                                        </CButton>
                                    </div>


                                    {item.suggestions && (
                                        <ul className="list-group mt-4 mx-4">
                                            <AccordianSuggestion
                                                suggestions={item?.suggestions?.suggestionName}
                                                parentId={item.id}
                                                orders={item?.suggestions?.orders}
                                                onSuggestionsChange={handleSuggestionsChange}
                                                setSaveResoanChange={setSaveResoanChange}
                                            />
                                        </ul>
                                    )}

                                    {item.children.length > 0 && (
                                        <div className="mt-4">{renderAccordions(item.children)}</div>
                                    )}
                                </div>
                            }
                        />

                    ))}
                </div>
            </CRow>

        </div>
    }



    return (
        <>
            <div>

                {activeTab === 'add' && <div className=" rounded-1 bg-white d-flex justify-content-around gap-4" style={{ height: '100vh' }}>

                    <div>
                        <div
                            className="bg-white p-4  m-2 mt-4 "
                            style={{
                                borderRadius: '10px',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                marginBottom: '20px',
                                width: '350px',
                                height: '200px'
                            }}
                        >
                            <div className="mb-3" style={{ width: '100%' }}>
                                <CFormLabel style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                    Select Diagnosis
                                </CFormLabel>
                                <Select
                                    value={selectedDiagnosis}
                                    onChange={setSelectedDiagnosis}
                                    options={diagnosisOptions}

                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderRadius: '8px',
                                            padding: '2px',
                                            borderColor: '#dfe1e5',
                                            boxShadow: 'none',
                                            fontSize: '15px',
                                        }),
                                    }}
                                />
                            </div>

                            <div className=" d-flex justify-content-center gap-2">
                                <CButton
                                    variant="outline"
                                    onClick={handleOnClick}
                                    color="primary"
                                >
                                    Add Title
                                </CButton>
                                <CButton
                                    variant="outline"
                                    color="primary"
                                    onClick={handleOnClick}

                                >
                                    Add Suggestions
                                </CButton>
                            </div>

                        </div>
                        <div className=" text-end me-2 ">
                            <CButton onClick={() => { handelSubmit() }} className="px-4">Submit</CButton>
                        </div>
                    </div>
                    <div className=" shadow-ex p-2" style={{ height: '90vh', overflow: 'auto', width: '50vw' }}>
                        {renderAccordions(accordions?.accordions)}
                    </div>


                </div>}


                <CModal
                    size="md"
                    visible={modalVisible}
                    onClose={() => {
                        setModalVisible(false);
                        setAssessment([]);
                        setPlans([]);
                    }}
                >
                    <CModalHeader onClose={() => {
                        setModalVisible(false);
                        setAssessment([]);
                        setPlans([]);
                    }}>
                        <CModalTitle>{editMode ? 'Edit Header' : 'Add Header'}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        {modalVisible && (
                            <>

                                <div className="border mt-0 p-2 py-4 rounded">
                                    <div className='w-100'>
                                        <p className='font-weight-large mb-2' style={{ fontSize: '13px' }}>Header</p>
                                        <CFormInput
                                            name='Title'
                                            value={newTitle}
                                            onChange={(e) => setNewTitle(e.target.value)}
                                            type='text'
                                            placeholder=''
                                            className='h-25'
                                        />
                                    </div>

                                </div>
                            </>
                        )}
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={() => {
                            setModalVisible(false);
                            setKeywords([]);
                            setPlans([]);
                            setEditingAccordionId(null)
                        }}>Close</CButton>
                        <CButton color="primary" onClick={() => addAccordion(currentParentId)}>
                            {
                                isLoading ?
                                    <>
                                        <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                                        Loading...
                                    </>
                                    : (
                                        editMode ? 'Edit ' : 'Add '
                                    )
                            }
                        </CButton>
                    </CModalFooter>
                </CModal>


                <CModal
                    size=""
                    visible={suggestionModalVisible}
                    onClose={() => {
                        setSuggestionModalVisible(false);
                        setSuggestionTitle([])
                        setEditMode(false);

                    }}
                >
                    <CModalHeader onClose={() => {
                        setSuggestionModalVisible(false);
                        setSuggestionTitle([])
                        setEditMode(false);

                    }}>
                        <CModalTitle>{isEditing ? 'Edit Suggestion' : 'Add Suggestion'}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        {suggestionModalVisible && (
                            <>
                                <div className=" mt-0 p-2 py-4 rounded">
                                    <div className='w-100'>
                                        <div className="w-100 p-3 border rounded shadow-sm bg-light">
                                            <ReasonSuggestion className='mb-3' label='Suggestion' keywords={suggestionTitle} setKeywords={setSuggestionTitle} />
                                        </div>
                                        <div>
                                            {/* <AccordianSuggestion
                                                suggestions={suggestionTitle}
                                                onSuggestionsChange={handleSuggestionsChange}
                                                parentId={suggestionId}
                                            /> */}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </CModalBody>

                    <CModalFooter>
                        <CButton color="secondary" onClick={() => {
                            setSuggestionModalVisible(false);
                            setSuggestionTitle([])
                            setEditMode(false);
                        }}>Close</CButton>
                        <CButton color="primary" onClick={() => { setSuggestionModalVisible(false), editMode ? editSuggestion(suggestionId, suggestionIndex) : addSuggestion(suggestionId) }}>
                            {
                                isLoading ?
                                    <>
                                        <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                                        Loading...
                                    </>
                                    : (
                                        'Add '
                                    )
                            }
                        </CButton>
                    </CModalFooter>
                </CModal>


                <CModal
                    visible={deleteVisibleId}
                >
                    <CModalHeader>
                        <CModalTitle>Warning</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
                    </CModalBody>
                    <hr className="p-0 m-0" />
                    <CModalFooter className="p-3 m-0">
                        <CButton
                            onClick={() => {
                                setDeleteVisibleId(null)
                            }}
                            className="text-white" color="secondary">Close</CButton>
                        <CButton onClick={deleteDiagnosis} className="text-white" color="danger">Delete</CButton>
                    </CModalFooter>
                </CModal>
                <Pageloader isLoading={isPageLoading} />
            </div>



        </>
    );
};

export default SuggestionDiagnosis;
